export default __webpack_public_path__ + "static/media/eth2x_fli.7327930b.svg";